import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NavigationService } from '@services/support/navigation.service';
import { Subscription } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { ModalService } from '@services/support/modal.service';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  @ViewChild("logoutTemplate", { static: true }) private logoutTemplate: TemplateRef<any>;

  sidebarOpen: boolean = false;
  sidebarSub: Subscription = null;

  appVersion:string = "";

  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private modalService: ModalService
  ) {
    this.sidebarSub = this.navigationService.sidebarState.subscribe(state => {
      this.sidebarOpen = state;
    });
  }

  ngOnInit() {
    this.appVersion = environment.version;
  }

  toggleSidebar() {
    this.navigationService.toggleSidebar();
  }

  ngOnDestroy() {
    if (this.sidebarSub) { this.sidebarSub.unsubscribe() }
  }

  onLogout() {
    const modalId = this.modalService.show({
      template: this.logoutTemplate,
      context: {
        dataModel: null,
        callbacks: {
          close: () => {
            this.modalService.hide(modalId);
          },
          logout: () => {
            this.modalService.hide(modalId);
            this.authService.logout();
          }
        }
      }
    });
  }
}
